import { shade } from 'polished';
import styled, { css, FlattenInterpolation, ThemeProps } from 'styled-components';
import { buttonResetStyleIncludingFocus } from '../../../commonStyles/buttonReset';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Theme } from '../../../theme';
import Link from '../../Link';
import {
  desktopHeaderHeight,
  headerItemFlex,
  navItemSelectedBarHeight,
} from '../Header/styles';
import { IsActiveProps } from '../types';

export const transitionLength = '0.3s';
export const focusBoxShadowWidthPx = 2;
export const navItemSelectedBar = (
  color: ({ theme }: ThemeProps<Theme>) => string
): FlattenInterpolation<ThemeProps<Theme> & IsActiveProps> => css<IsActiveProps>`
  &:after {
    content: '';
    display: block;
    border-bottom: solid ${navItemSelectedBarHeight} ${color};
    transform: scaleX(${({ isActive }) => (isActive ? 1 : 0)});
    transition: transform ${transitionLength} ease-out;

    position: absolute;
    top: calc(${desktopHeaderHeight} - ${focusBoxShadowWidthPx / 2}px);
    width: 100%;
  }

  &:hover:after {
    transform: scaleX(1);
  }
`;

export const rotateArrowWhenSelected = css<IsActiveProps>`
  svg {
    transition: transform ${transitionLength} ease-out;

    ${({ isActive }) =>
      isActive &&
      css`
        transform: rotate(-180deg);
      `}
  }
`;

export const darkenOnHover = css<{ isActive: boolean }>`
  transition: background-color ${transitionLength} ease-out;
  ${({ isActive }) =>
    !isActive &&
    css`
      &:hover {
        background: ${({ theme }) => shade(0.3, theme.colors.core02)};
      }
    `}
`;

export const InlineNav = styled.div`
  display: none;
  flex: ${headerItemFlex};

  ${mediaQuery.tabletLandscape`
    display: flex;
    justify-content: center;
  `}
`;

export const NavItemText = styled.span`
  ${fonts.paragraph}
  & {
    color: ${colors.neutral08};
    font-weight: lighter;
  }
  white-space: nowrap;

  margin: ${spacing(3)} 0;
  padding: 0 ${spacing(3)};
`;

export const NavItemWithoutBorderStyling = css`
  ${buttonResetStyleIncludingFocus};
  position: relative;

  ${darkenOnHover}

  height: calc(100% - ${focusBoxShadowWidthPx}px);
  margin: ${focusBoxShadowWidthPx / 2}px 0;


  &:focus-visible {
    /* Have half of the border inset and half on the outside so that it will overlap
    the divider line between the nav items. */
    box-shadow: inset ${colors.neutral08} 0 0 0 ${focusBoxShadowWidthPx / 2}px,
      ${colors.neutral08} 0 0 0 ${focusBoxShadowWidthPx / 2}px;
    border-radius: 8px;
    /* Put the focussed element above its neighbours to ensure nothing overlaps the
    focus outline. */
    z-index: 1;
  }

  &:hover ${NavItemText} {
    & {
      font-weight: unset;
    }
  }
`;

export const NavItemWithoutBorder = styled.button<IsActiveProps>`
  ${NavItemWithoutBorderStyling};
`;
export const NavItemLinkWithoutBorder = styled(Link)`
  ${NavItemWithoutBorderStyling};
`;
export const DummySecondaryNav = styled.div`
  ${mediaQuery.tabletLandscape`
    flex: 1;
  `}
`;
